import { create } from 'zustand';

interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isLoaded: boolean;
  isMobileOrTablet: boolean;
  setResponsive: (isMobile: boolean, isTablet: boolean, isDesktop: boolean) => void;
  setLoaded: (isLoaded: boolean) => void;
  initializeResponsive: () => () => void;
}

export const useResponsiveStore = create<ResponsiveState>((set, get) => ({
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isLoaded: false,
  isMobileOrTablet: false,
  
  setResponsive: (isMobile: boolean, isTablet: boolean, isDesktop: boolean) => 
    set({ 
      isMobile, 
      isTablet, 
      isDesktop, 
      isMobileOrTablet: isMobile || isTablet 
    }),
  
  setLoaded: (isLoaded: boolean) => set({ isLoaded }),
  
  initializeResponsive: () => {
    // Función para detectar el tamaño de pantalla
    const checkScreenSize = () => {
      const width = window.innerWidth;
      
      const isMobile = width < 768;
      const isTablet = width >= 768 && width < 1024;
      const isDesktop = width >= 1024;
      
      set({ 
        isMobile, 
        isTablet, 
        isDesktop, 
        isMobileOrTablet: isMobile || isTablet,
        isLoaded: true 
      });
    };

    // Verificar si estamos en el navegador
    if (typeof window !== 'undefined') {
      // Detectar inicialmente
      checkScreenSize();
      
      // Escuchar cambios de tamaño de ventana
      window.addEventListener('resize', checkScreenSize);
      
      // Cleanup function (se ejecutará cuando el componente se desmonte)
      return () => {
        window.removeEventListener('resize', checkScreenSize);
      };
    } else {
      // En SSR, establecer valores por defecto
      set({ 
        isMobile: false, 
        isTablet: false, 
        isDesktop: true, 
        isMobileOrTablet: false, 
        isLoaded: true 
      });
      return () => {}; // No-op cleanup para SSR
    }
  },
})); 